<template>
  <b-modal
    :visible="visible"
    title="Editar Envolvido"
    size="lg"
    centered
    hide-footer
    no-close-on-backdrop
    @update:visible="$emit('update:visible', $event)"
    @shown="onShown"
  >
    <InvolvedPersonForm
      v-if="form"
      v-model="form"
      :errors="errors"
    />

    <div class="d-flex justify-content-between align-items-center mt-2">
      <button
        type="button"
        class="btn btn-outline-secondary"
        @click="$emit('update:visible', false)"
      >
        Fechar
      </button>
      <button
        type="button"
        class="btn btn-primary"
        :disabled="saving"
        @click="submit"
      >
        <b-spinner
          v-if="saving"
          small
          class="mr-25"
        />
        <feather-icon
          v-else
          icon="SaveIcon"
          size="14"
          class="mr-25"
        />
        Salvar
      </button>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BSpinner } from 'bootstrap-vue'
import InvolvedPersonForm from './InvolvedPersonForm.vue'

const PERSON_FIELDS = [
  'unidentified', 'name', 'apparent_description', 'age', 'age_unit', 'gender',
  'social_name', 'cpf', 'rg', 'cns', 'birth_date', 'race', 'telephone', 'cellphone',
]

export default {
  name: 'OccurrenceInvolvedEditModal',

  components: { BModal, BSpinner, InvolvedPersonForm },

  props: {
    visible: { type: Boolean, default: false },
    /** occurrence_involved (com `.entity` carregado) da pessoa a editar. */
    involved: { type: Object, default: null },
  },

  data() {
    return {
      form: null,
      errors: {},
      saving: false,
    }
  },

  methods: {
    onShown() {
      const entity = (this.involved && this.involved.entity) || {}
      const form = {}
      PERSON_FIELDS.forEach(f => {
        form[f] = entity[f] ?? (f === 'age_unit' ? 'anos' : '')
      })
      form.unidentified = !!entity.unidentified
      this.form = form
      this.errors = {}
    },

    async submit() {
      const entityId = this.involved && this.involved.entity_id
      if (!entityId) return

      this.saving = true
      try {
        await this.$http.put(`${this.$store.state.api}involveds/${entityId}`, this.form)
        this.$message('Sucesso', 'Envolvido atualizado.', 'success')
        this.$emit('edited')
        this.$emit('update:visible', false)
      } catch (e) {
        const msg = (e.response && e.response.data) || 'Erro ao atualizar envolvido.'
        this.$message('Erro', typeof msg === 'string' ? msg : 'Erro ao atualizar envolvido.', 'error')
      } finally {
        this.saving = false
      }
    },
  },
}
</script>
